<template>
    <div class="app-layout">
        <PageLoader :isLoading="!isRouterReady" />
        <SiteNav v-if="!hideChrome" />
        <router-view class="app-content" />
        <div v-if="!hideChrome" class="footer-wrapper">
            <SiteFooter v-if="isMounted" />
        </div>
    </div>
</template>

<script lang="ts">
import { defineComponent, ref, watch, onMounted, nextTick, computed } from "vue";
import { useRoute, useRouter } from "vue-router";
import SiteNav from "./components/SiteNav.vue";
import SiteFooter from "./views/SiteFooterView.vue";
import PageLoader from "./components/PageLoader.vue";
import MerchantService from "./services/merchant-service";
import { useTenantConfig } from "./composables/useTenantConfig";
import FadeInWrapper from "./components/FadeInWrapper.vue";
import { showPendingSuccessPopup } from "./utils/global";
import { useAuthStore } from "./stores/auth";

export default defineComponent({
  name: "App",
  components: {
    SiteNav,
    SiteFooter,
    PageLoader,
  },
  setup() {
    const { branding, settings } = useTenantConfig();
    const isMounted = ref(false);
    const isRouterReady = ref(false);
    const router = useRouter();
    const route = useRoute();
    const authStore = useAuthStore();

    const hideChrome = computed(() => route.meta?.hideChrome === true);

    router.isReady().then(() => {
      isRouterReady.value = true;
    });

    router.afterEach(() => {
      nextTick(() => {
        showPendingSuccessPopup();
      });
    });

    onMounted(() => {
      authStore.checkAuthentication();

      const siteId = settings.value?.tenantSettings?.find((x) => x.name === "CmsSiteId") ?.value ?? "";
      const applicationName = settings.value?.tenantSettings?.find((x) => x.name === "ApplicationName")?.value ?? "";
      const clubId = settings.value?.tenantSettings?.find((x) => x.name === "ClubId") ?.value ?? "";

      MerchantService.getSearchMerchantsData(siteId, applicationName, clubId);

      isMounted.value = true;
    });

    return { branding, isMounted, isRouterReady, hideChrome };
  },
});
</script>

<style scoped>
.app-layout {
  display: flex;
  flex-direction: column;
  min-height: 100vh;
}

.app-content {
  flex: 0 0 auto;
}

.footer-wrapper {
  flex: 1 0 auto;
  display: flex;
  flex-direction: column;
  background: var(--tenant-primary-color);
}
</style>
